// extracted by mini-css-extract-plugin
module.exports = {"taskNotCompleteClickable":"styles__taskNotCompleteClickable___2g2gt","taskCompleteClickable":"styles__taskCompleteClickable___3v_Vd"};